import axios from 'axios'

const password = 'user-property'

export default {
  getFullVacantProperties (context) {
    axios.get(`${password}/full-list`).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setFullVacantProperties(response.data)
    }, () => {
    })
  },
  getFullVacantPropertiesList (context) {
    const params = {params: { page: context.selectedPage - 1}}
    axios.get(`${password}`, params).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setFullVacantProperties(response.data)
    }, () => {
    })
  },
  getFullVacantPropertyById (context, id) {
    axios.get(`${password}/${id}`).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setFullVacantPropertyId(response.data)
    }, () => {
    })
  }
}
